import { functions } from "./firebase";
import { httpsCallable } from "firebase/functions";

// functions.httpsCallable("createCustomer") ---> returns callable functions
const shopify = {
  createCustomer: httpsCallable(functions, "createCustomer"),
  updateCustomer: httpsCallable(functions, "updateCustomer"),
  deleteCustomer: httpsCallable(functions, "deleteCustomer"),
  inviteCustomer: httpsCallable(functions, "inviteCustomer"),
  newCompanyAccess: httpsCallable(functions, "newCompanyAccess"),
  // The shared grant path (ADR-0009). Pass `dry_run: true` for a plan without writes.
  // This is what the New Access screen calls — it superseded the browser-side orchestration.
  grantCompanyAccess: httpsCallable(functions, "grantCompanyAccess"),
  // The shared pause / resume / revoke path (ADR-0012): one record or "all", `dry_run` to preview.
  // The company page's buttons call this — it superseded the browser-side orchestration. 300 s,
  // matching the function: "all" on a large company is a job write per User per product, and the
  // SDK's 70 s default would report a failure for a change that is still running.
  changeCompanyAccess: httpsCallable(functions, "changeCompanyAccess", { timeout: 300000 }),
  // The shared add-Users path (ADR-0014): one brand-new User, `dry_run` to preview. The New User
  // screen calls this for a brand-new email only — a Linked User (one who already exists under
  // another Company) still runs the screen's own separate, unchanged path.
  addCompanyUsers: httpsCallable(functions, "addCompanyUsers"),
  updateCompanyAccess: httpsCallable(functions, "updateCompanyAccess"),
  deleteCompanyAccess: httpsCallable(functions, "deleteCompanyAccess"),
  exportUsers: httpsCallable(functions, "exportUsers"),
  deleteExport: httpsCallable(functions, "deleteExport"),
  getRlsDimensions: httpsCallable(functions, "fetchRlsDims"),
  removeRlsAccessFromClient: httpsCallable(functions, "removeRlsAccessFromClient"),
  grantRlsAccessToClient: httpsCallable(functions, "grantRlsAccessToClient"),
  linkShopifyStore: httpsCallable(functions, "install"),
  resyncAccess: httpsCallable(functions, "resyncAccess"),
  loadViewAs: httpsCallable(functions, "loadViewAs"),
  previewCreateProduct: httpsCallable(functions, "previewCreateProduct"),
  createProduct: httpsCallable(functions, "createProduct"),
  applyThemeEdits: httpsCallable(functions, "applyThemeEdits"),
  previewUpdateEmbed: httpsCallable(functions, "previewUpdateEmbed"),
  updateProductEmbed: httpsCallable(functions, "updateProductEmbed"),
  setSourceResourceLink: httpsCallable(functions, "setSourceResourceLink"),
};

export { shopify };
